module.exports = __webpack_public_path__ + "static/img/join_3.909443a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join_3.jpg
// module id = ZCXu
// module chunks = 1